/* eslint-disable import/prefer-default-export */
import globalApi from '@/request/globalApi/globalApi'

const END_POINT = 'api/providers-for-airport'

// MAIN
export const fetchProvidersForAirportRequest = (airportId, params) => globalApi.get(`${END_POINT}/${airportId}`, { params })
